import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { Monitors } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/monitors`,
    response: {} as Monitors.Get.Response,
    query: {} as { after?: string },
    method: HTTP_METHODS.GET,
  },
};
